import { Form } from "react-bootstrap";
import sketchUtilities from "../../../utilities/sketchUtilities";
import TelusLimitDetailFields from "./telusLimitDetailFields";

const createDefaultLimitDetail = (limitIndex) => ({ limitIndex, fromAddress: '', toAddress: '', serviceCount: '' });

export default function TelusReportLimitDetails(props) {
    const { limits, language, selectedLimitIndices, onToggleLimit, allLimitDetails, onChange } = props;
    const isLimitSelected = (limitIndex) => selectedLimitIndices.includes(limitIndex);

    const getLimitDetail = (limitIndex) =>
        allLimitDetails.find(reportLimitDetail => reportLimitDetail.limitIndex === limitIndex) ?? createDefaultLimitDetail(limitIndex);

    const updateLimitDetail = (updatedReportLimitDetail) => {
        const existingIndex = allLimitDetails.findIndex(reportLimitDetail => reportLimitDetail.limitIndex === updatedReportLimitDetail.limitIndex);
        let updatedAllLimitDetails;

        if (existingIndex > -1) {
            updatedAllLimitDetails = allLimitDetails.toSpliced(existingIndex, 1, updatedReportLimitDetail);
        }
        else {
            updatedAllLimitDetails = [...allLimitDetails, updatedReportLimitDetail];
        }

        onChange(updatedAllLimitDetails);
    };

    if (limits.length <= 1)
    {
        return <TelusLimitDetailFields reportLimitDetail={getLimitDetail(0)} language={language} onChange={updateLimitDetail} />;
    }

    return (
        <Form.Group className="mb-3">
            <Form.Label className='text-body fs-sm fw-semibold'>{language === 'fr' ? 'Limites' : 'Limits'}</Form.Label>
            {limits.map((_, limitIndex) => (
                <div className='mb-2' key={limitIndex}>
                    <div className='d-flex align-items-center mb-2'>
                        <Form.Check
                            type='switch'
                            id={`telus-limit-${limitIndex}`}
                            checked={isLimitSelected(limitIndex)}
                            onChange={() => onToggleLimit(limitIndex)}
                            className='me-2'
                        />
                        <p className='mb-0 fs-sm'>{sketchUtilities.getLimitName(limits, limitIndex)}</p>
                    </div>
                    {isLimitSelected(limitIndex) && (
                        <TelusLimitDetailFields
                            key={limitIndex}
                            reportLimitDetail={getLimitDetail(limitIndex)}
                            language={language}
                            onChange={updateLimitDetail}
                        />
                    )}
                </div>
            ))}
        </Form.Group>
    );
}
